import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import withRender from './DataCustomLabelViewer.html';

@withRender
@Component({
  components: {
  },
  diProvide: [],
})
export default class DataCustomLabelViewer extends Vue {

  @Prop({ type: String, default: '' }) public label!: string;
  @Prop({ type: String, default: '' }) public value!: string;


  public mounted() {


  }



}
